import { Injectable } from '@angular/core';

import { AuthService } from '@core/services';

@Injectable()
export class AdminGuard {
  constructor(private authService: AuthService) {}

  async canActivate() {
    return this.authService.user.isAdmin;
  }
}
